var config = {
  baseUrl: "",
  appId: ""
};
if (location.href.includes("choiceedu.com")) {
  config = {
    baseUrl: "http://api.choiceedu.com/"
  };
} else if (location.href.includes("yaoqingwo.com")) {
  config = {
    baseUrl: "http://choice-api.yaoqingwo.com/"
  };
} else {
  config = {
    // baseUrl: 'https://choice-api.lmh5.com/',
    // baseUrl: "http://choice-api.yaoqingwo.com/"
    baseUrl: "http://api.choiceedu.com/"
  };
}

export default config;



// WEBPACK FOOTER //
// ./src/utils/config.js